import hexToRGBA from "../../../hexToRGBA";
import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const iconButton = (config: InternalThemeConfig): ComponentsOverrides<Theme>["MuiIconButton"] => {
	const { palette, spacing } = config;
	return {
		root: {
			padding: spacing(0.625),
			minWidth: "0",
			margin: 0,

			"&.MuiIconButton-edgeStart": {
				marginLeft: "-0.5rem",
			},

			"&:hover": {
				backgroundColor: hexToRGBA(palette.primary, 0.12),
			},
			"@media (hover: none)": {
				"&:hover": {
					background: `none`,
				},
			},
			"&:active": {
				backgroundColor: hexToRGBA(palette.primary, 0.12),
			},
			"&:disabled": {
				color: undefined,
			},
		},
	};
};

export default iconButton;
